import './alert.scss'

export function init() {
  if ($('.flash.fixed').length) {
    $('body').append($('.flash.fixed').addClass('active'))
    setTimeout(function () {
      $('.flash.fixed').css('transform', 'translateY(-100%)')
    }, 5000)
  }
}

$(document).on('click', '.alert .close', function (event) {
  event.preventDefault()
  const $this = $(this)
  if ($this.closest('.js-flash-message-container').length) {
    $this.closest('.js-flash-message-container').addClass('hidden')
  } else {
    const $flash = $this.closest('.wrapper.flash')
    $this.closest('.alert').addClass('hidden')
    if (!$flash.find('.alert').length) {
      $flash.addClass('hidden')
    }
  }
})

init()
